import { certificatesFields, documentFields } from "./queries.constants";

export const getSupplyChainQuery = (orgId: string, supplyChainId: string) => `
{
    loadSupplyChain(
        orgId: "${orgId}"
        supplyChainId: "${supplyChainId}"
    ) {
        id
        name
        description
        recordState
        links {
            from {
                id
                name
            }
            to {
                id
                name
            }
        }
        locations {
            location {
                id
                name
                geoLocation
                types {
                    type
                    pointOfOrigin
                }
                address {
                    country
                }
                connections {
                    id
                    name
                    documents {
                        ${documentFields}
                    }
                    certificates {
                        ${certificatesFields}
                    }
                }
                documents {
                    ${documentFields}
                }
                certificates {
                    ${certificatesFields}
                    tags {
                        title
                        color
                    }
                }
            }
            documents {
                ${documentFields}
            }
            certificates {
                ${certificatesFields}
                tags {
                    title
                    color
                }
            }
        }
    }
}
`;
